import * as React from "react";

export default class Tabs extends React.Component<any> {
    constructor(props) {
        super(props);
    }
    
    _children() {
        const { children = [] } = this.props;
        return (children as any).map( (child, index) => {
            return React.cloneElement(child, {
                onClick : () => this.changeTab(child.key),
                // tabIndex: index,
                className: (child.key === this.props.activeKey) ? "active" : ""
            });
        } );
    }
    
    changeTab( key ) {
        if (this.props.onChange) {
            this.props.onChange( key );
        }
    }
    
    render() {
        const { children } = this.props;
        const { } = this.state;
        
        return (
          <nav className="UI_Tabs">
            {this._children()}
          </nav>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/Tabs.tsx